/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateDocumentRuleDtoGen,
  MrfiktivDocumentIdsAiDtoGen,
  MrfiktivDocumentRuleControllerGetParamsGen,
  MrfiktivDocumentRuleViewModelGen,
  MrfiktivImproveDocumentRuleDtoGen,
  MrfiktivLinkAdminRuleDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivPartnerOperationViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DocumentRule<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags document-rule
   * @name DocumentRuleControllerCreate
   * @summary (Document rule - CREATE) Create a document rule
   * @request POST:/partner/{partnerId}/document-rule
   * @secure
   * @response `201` `MrfiktivDocumentRuleViewModelGen` The created document rule
   */
  documentRuleControllerCreate = (
    partnerId: string,
    data: MrfiktivCreateDocumentRuleDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRuleViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule
   * @name DocumentRuleControllerGet
   * @summary (Document rule - READ) Get all Rules
   * @request GET:/partner/{partnerId}/document-rule
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivDocumentRuleViewModelGen)[] })`
   */
  documentRuleControllerGet = (
    { partnerId, ...query }: MrfiktivDocumentRuleControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivDocumentRuleViewModelGen[] }, any>({
      path: `/partner/${partnerId}/document-rule`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule
   * @name DocumentRuleControllerImprove
   * @summary (Document rule - IMPROVE) Analyse and improve a rule using AI
   * @request POST:/partner/{partnerId}/document-rule/improve
   * @secure
   * @response `201` `MrfiktivPartnerOperationViewModelGen` Operation dispatched for the rule improvement
   */
  documentRuleControllerImprove = (
    partnerId: string,
    data: MrfiktivImproveDocumentRuleDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerOperationViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule/improve`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule
   * @name DocumentRuleControllerTest
   * @summary (Document rule - TEST) Run a single rule against a document as a test
   * @request POST:/partner/{partnerId}/document-rule/{documentRuleId}/test
   * @secure
   * @response `201` `MrfiktivPartnerOperationViewModelGen` Operation dispatched for the rule test
   */
  documentRuleControllerTest = (
    partnerId: string,
    documentRuleId: string,
    data: MrfiktivDocumentIdsAiDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerOperationViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule/${documentRuleId}/test`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule
   * @name DocumentRuleControllerGetOne
   * @summary (Document rule - READ) Get a document rule
   * @request GET:/partner/{partnerId}/document-rule/{documentRuleId}
   * @secure
   * @response `200` `MrfiktivDocumentRuleViewModelGen` The document rule
   */
  documentRuleControllerGetOne = (partnerId: string, documentRuleId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDocumentRuleViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule/${documentRuleId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule
   * @name DocumentRuleControllerUpdate
   * @summary (Document rule - UPDATE) Updates a document rule
   * @request PATCH:/partner/{partnerId}/document-rule/{documentRuleId}
   * @secure
   * @response `201` `MrfiktivDocumentRuleViewModelGen` The updated document rule
   */
  documentRuleControllerUpdate = (
    partnerId: string,
    documentRuleId: string,
    data: MrfiktivCreateDocumentRuleDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRuleViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule/${documentRuleId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule
   * @name DocumentRuleControllerDelete
   * @summary (Document rule - DELETE) Deletes a document rule
   * @request DELETE:/partner/{partnerId}/document-rule/{documentRuleId}
   * @secure
   * @response `200` `MrfiktivDocumentRuleViewModelGen` The deleted document rule
   */
  documentRuleControllerDelete = (partnerId: string, documentRuleId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDocumentRuleViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule/${documentRuleId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule
   * @name DocumentRuleAdminControllerLink
   * @summary (ADMIN) Link or unlink a partner document rule to an admin rule
   * @request PATCH:/partner/{partnerId}/document-rule/{documentRuleId}/admin-rule
   * @secure
   * @response `201` `MrfiktivDocumentRuleViewModelGen` The updated document rule
   */
  documentRuleAdminControllerLink = (
    partnerId: string,
    documentRuleId: string,
    data: MrfiktivLinkAdminRuleDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRuleViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule/${documentRuleId}/admin-rule`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
